import { Routes } from 'types/global.type';

export const authRoutes = [Routes.login, Routes.signUp];
